export const CLP = {
    sign: 'CLP$',
    name: 'CLP',
};
